import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Typography, Button } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import { styles } from "./constants/styles";
import messages from "./constants/messages";
import { useLocation } from "react-router";
import { UsePasswordResetRequest } from "../../shared/hooks/usePasswordResetRequest";
import { useRepeatSendEmail } from "../../shared/hooks/useRepeatSendEmail";
import { CheckLifeTimeTypeLinks } from "../../shared/services/AuthService";

type Props = WithStyles<typeof styles>;

const NewLinkPage: React.FC<Props> = (props: Props) => {
  const { classes } = props;
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const email = useQuery().get("email") || "";
  const type = (useQuery().get("type") as CheckLifeTimeTypeLinks) || CheckLifeTimeTypeLinks.None;
  const [emailState] = React.useState<string>(email);
  const [typeState] = React.useState<CheckLifeTimeTypeLinks>(type);
  const [requestHasBeenSent, setRequestHasBeenSent] = React.useState<boolean>(false);
  const [, passwordResetRequest] = UsePasswordResetRequest();
  const [, repeatSendConfirmationEmail, repeatSendInviteEmail, repeatSendPassWordExpiredEmail] = useRepeatSendEmail();

  const handleApply = () => {
    if (emailState) {
      switch (typeState) {
        case CheckLifeTimeTypeLinks.ResetPassword:
          passwordResetRequest(emailState, true);
          break;
        case CheckLifeTimeTypeLinks.PasswordAdd:
          repeatSendInviteEmail(emailState);
          break;
        case CheckLifeTimeTypeLinks.EmailConfirm:
          repeatSendConfirmationEmail(emailState);
          break;
        case CheckLifeTimeTypeLinks.ExpiredPassword:
          repeatSendPassWordExpiredEmail(emailState);
          break;
        default:
          break;
      }

      setRequestHasBeenSent(true);
    }
  };

  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <Typography className={classes.header}>
          {requestHasBeenSent ? (
            <FormattedMessage {...messages.headerSentNewLink} />
          ) : (
            <FormattedMessage {...messages.headerNoValidLink} />
          )}
        </Typography>
        {!requestHasBeenSent && (
          <Button variant="contained" color="primary" onClick={handleApply} classes={{ root: classes.button }}>
            <FormattedMessage {...messages.btnNewLink} />
          </Button>
        )}
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(NewLinkPage);
